import type { ComponentProps } from 'react'
import { cn } from '@app/lib/cn'

export type InputProps = ComponentProps<'input'> & {
  /** Codes and barcodes read better in mono with tabular figures. */
  mono?: boolean
}

export function Input({ className, mono = false, ...props }: InputProps) {
  return (
    <input
      className={cn(
        'h-8 w-full rounded-xs border border-hairline bg-surface px-2 text-data text-ink',
        'transition-colors placeholder:text-ink-muted/70',
        'hover:border-ink-muted/45',
        'focus-visible:border-kordovan focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-kordovan/25',
        'disabled:cursor-not-allowed disabled:opacity-50',
        mono && 'font-mono tnum',
        className,
      )}
      {...props}
    />
  )
}
